/**
 * Post a single screening answer for the current next_question.
 */
import {answerScreening} from '@/intake/sandboxMatchApi'
import {applySessionToStore, currentWriteRevision, nextClientSeq} from '@/intake/screeningSession'

/**
 * @param {string|number} intakeId
 * @param {{question_id:string, answer_ids:string[], ages?:any[], participant_ref?:string}} answer
 * @returns {Promise<{session: object}>}
 */
export async function postScreeningAnswer(intakeId, answer) {
  if (!answer || !answer.question_id) {
    return {session: null}
  }

  const body = {
    question_id: answer.question_id,
    answer_ids: answer.answer_ids || [],
    client_seq: nextClientSeq(),
    client_revision: currentWriteRevision(),
  }
  if (answer.participant_ref) {
    body.participant_ref = answer.participant_ref
  }
  if (answer.ages) {
    body.ages = answer.ages
  }
  if (answer.respondent_confirmation === 'FOCAL_PARTICIPANT_SELF') {
    body.respondent_confirmation = answer.respondent_confirmation
  }

  const session = await answerScreening(intakeId, body)
  applySessionToStore(session, {
    s1Intent: Object.prototype.hasOwnProperty.call(session || {}, 's1_intent')
      ? (session.s1_intent || null)
      : undefined,
  })

  return {session}
}
